import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {BreadcrumbComponent} from './breadcrumb-component/breadcrumb.component';
import {BreadcrumbItemDirective} from './breadcrumb-item.directive';


@NgModule({

  declarations: [
    BreadcrumbComponent, BreadcrumbItemDirective
  ],
  exports: [
    BreadcrumbComponent, BreadcrumbItemDirective
  ],
  imports: [
   CommonModule,
    RouterModule
  ]

})
export class BreadcrumbsModule {
}
